import React, { useEffect, useState, useRef } from 'react';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Checkbox, FormControlLabel, Radio, Tab, Button, MenuItem, Select } from '@mui/material';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import icon_child from '../../_theme/_assets/images/icon__child.svg';
import icon_adult from '../../_theme/_assets/images/icon_adult.svg';
import icon_childfriendly from '../../_theme/_assets/images/icon_sharp-child-friendly.svg';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getOneTarif } from '../thunks/getOneTarif';
import { useHistory } from 'react-router-dom';
import { putBulkUpdate } from '../thunks/putBulkUpdate';
import swal from 'sweetalert';
import { upsertNewPrix } from '../thunks/upsertNewPrix';
import { parseISO, format } from 'date-fns'
import CustomDateInput from '../../components/common components/CustomDateInput';
import { TextField } from '@material-ui/core';
import { useLocation } from "react-router-dom";
import { getClassData } from '../thunks/getClassData';
import { getOnePrix } from '../thunks/getOnePrix';
import SpinnerLoader from '../../pages/bookingConfirmation/Utils/spinner';
import { getcontracts } from '../../pages/bookingConfirmation/thunks/getcontracts';
import { showDetailedErrorSwal } from '../../components/common components/showErrorSwal';
import { applyAction, BLACKOUT_CARRIER_ACTION, reverseBlackOutCarrierPayload } from '../NewContractlist/Constant';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const NewPrix = () => {
    const isEmpty = (obj) => Object.keys(obj).length === 0;
    const history = useHistory();
    const query = useQuery();
    const URLTarifKey = query.get("tariff");
    const URLClassKey = query.get("class");
    const URLPrixKey = query.get("prix");
    console.log("URLPrixKey", URLPrixKey, "URLTarifKey", URLTarifKey, "URLClassKey", URLClassKey)
    // const tarifData = useSelector((state) => state.commonDataReducer.tarifData);
    // const classData = useSelector((state) => state.commonDataReducer.classData);
    // const prixDetails = useSelector((state) => state.commonDataReducer.prixDetail)
    const prixKeys = useSelector((state)=>state.commonDataReducer.prixKeys);
    const [createNew, setCreateNew] = useState(false)
    const [disableEdit, setDisableEdit] = useState(() => !createNew)
    const [updateLoader, setUpdateLoader] = useState(false)
    const [tarifValues, setTarifValues] = React.useState({});
    const [classValues, setClassValues] = React.useState({});
    const [prixDetailsLocal, setPrixDetailsLocal] = useState({
        commissionPercentage: "",
        markup: "",
        passBackCommission: "",
        childCommissionPercentage: "",
        childMarkUp: "",
        infantCommissionPercentage: "",
        infantMarkUp: "",
    });
    const [originalPrixData, setOriginalPrixData] = useState({});
    const [mandatoryFields, setMandatoryFields] = React.useState({
        "validFrom": false,
        "validTo": false,
    })
    const [loader, setLoader] = useState(false);
    const [prixArray, setPrixArray] = useState([])
    const [currentPrixIndex, setCurrentPrixIndex] = useState(0)
    const [nestedPayload, setNestedPayload] = useState({});
    const [disableOurCommissionForAdult, setDisableOurCommissionForAdult] = useState(false);
    const [disableOurCommissionForChild, setDisableOurCommissionForChild] = useState(false);
    const [disableOurCommissionForInfant, setDisableOurCommissionForInfant] = useState(false);
    const [disableOurMarkupForAdult, setDisableOurMarkupForAdult] = useState(false);
    const [disableOurMarkupForChild, setDisableOurMarkupForChild] = useState(false);
    const [disableOurMarkupForInfant, setDisableOurMarkupForInfant] = useState(false);
    const [disableAgencyCommissionForAdult, setDisableAgencyCommissionForAdult] = useState(false);
    const [disableAgencyCommissionForChild, setDisableAgencyCommissionForChild] = useState(false);
    const [disableAgencyCommissionForInfant, setDisableAgencyCommissionForInfant] = useState(false);

    let todaysDate = new Date();
    let maxDate = new Date('2030-12-31');
    const checkRegexInput = {
        commissionPercentage: /^[0-9+\-%$]+$/,
        childCommissionPercentage: /^[0-9+\-%$]+$/,
        infantCommissionPercentage: /^[0-9+\-%$]+$/,
        markup: /^[0-9$%]+$/,
        childMarkUp: /^[0-9$%]+$/,
        infantMarkUp: /^[0-9$%]+$/,
        passBackCommission: /^[0-9$%+-]+$/
    };

    useEffect(() => {
        if(URLTarifKey && URLClassKey && URLPrixKey){
            setCreateNew(false)
            setDisableEdit(true)
            getData()
        }else if(URLTarifKey && URLClassKey){
            setCreateNew(true)
            setDisableEdit(false)
            getData()
        }
    }, [URLTarifKey, URLClassKey, URLPrixKey])

    const getData = async () => {
        setLoader(true)
        let tarifDetails = await getOneTarif(URLTarifKey);
        if (tarifDetails.data) {
            setTarifValues(tarifDetails.data);
        }
        let classDetails = await getClassData(URLClassKey);
        if (classDetails) {
            setClassValues(classDetails);
            if(classDetails?.contractType == "Published") {
                setMandatoryFields(prev => ({
                    ...prev,
                    "commissionPercentage": false,
                    "childCommissionPercentage": false,
                    "infantCommissionPercentage": false,
                    "passBackCommission": false,
                
                }))

                setDisableOurMarkupForAdult(true)
                setDisableOurMarkupForChild(true)

            }else if(classDetails?.contractType == "Net") {
                setMandatoryFields(prev => ({
                    ...prev,
                    "markup": false,
                    "childMarkUp": false,
                    "infantMarkUp": false,
                }))
                // setDisableOurCommission(true);
                // setDisableAgencyCommission(true);
                setDisableOurCommissionForAdult(true);
                setDisableOurCommissionForChild(true);
                setDisableOurCommissionForInfant(true);
                setDisableAgencyCommissionForAdult(true);
                setDisableAgencyCommissionForChild(true);
                setDisableAgencyCommissionForInfant(true);
            }
        }
        if (URLPrixKey) {
            let prixDetails = await getOnePrix(URLPrixKey);
            if (prixDetails.data) {
                setPrixDetailsLocal(prixDetails.data);
                setOriginalPrixData(prixDetails.data)
                const {blackOutCarrier, prixKey} = prixDetails.data || {};
                setNestedPayload({[prixKey]: blackOutCarrier})
            }
        }else{
          setNestedPayload({["tempPrixKey"]: []});
        }
        setLoader(false)
    }
    useEffect(() => {
        // setPrixDetailsLocal({...prixDetails})
        let temp = originalPrixData?.tourCode
        let combinedObj = {}
        if (temp?.length) {
            temp.forEach((obj, index) => {
                if (Array.isArray(obj?.passengerType)) {
                    combinedObj[obj?.marketCode] = obj
                } else {

                    if (combinedObj[obj?.marketCode]) {
                        combinedObj[obj?.marketCode]["passengerType"].push(obj?.passengerType);
                    } else {
                        combinedObj[obj?.marketCode] = {
                            tourCodes: obj?.tourCodes,
                            marketCode: obj?.marketCode,
                            passengerType: [obj?.passengerType]
                        }
                    }
                }
            })
        }
        let localprixDetailsLocal = { ...prixDetailsLocal }
        localprixDetailsLocal['tourCode'] = Object.values(combinedObj)

        // let tempBlackOutCarrier = localprixDetailsLocal?.blackOutCarrier || [];
        // tempBlackOutCarrier.sort((a, b) => {
        //     // Compare carrierCode alphabetically
        //     if (a.carrierCode < b.carrierCode) return -1;
        //     if (a.carrierCode > b.carrierCode) return 1;

        //     // If carrierCode is same, compare flightNumberFrom numerically
        //     return Number(a.flightNumberFrom) - Number(b.flightNumberFrom);
        // });
        // localprixDetailsLocal['blackOutCarrier'] = tempBlackOutCarrier;
        setPrixDetailsLocal(localprixDetailsLocal)

    }, [originalPrixData])

    useEffect(() => {
        if (prixDetailsLocal?.tourCode?.length == 0) {
            let temp = prixDetailsLocal?.tourCode
            let combinedObj = {}
            if (temp?.length == 0) {
                combinedObj =
                {
                    "tourCodes": "",
                    "marketCode": "",
                    "passengerType": []
                }
            }
            let localprixDetailsLocal = { ...prixDetailsLocal }
            localprixDetailsLocal['tourCode'] = [combinedObj];
            setPrixDetailsLocal(localprixDetailsLocal)

        }
    }, [prixDetailsLocal]);

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue)
    };

    const commonOnChange = (key, newValue) => {
        let copyMandatoryFields = { ...mandatoryFields };

        const pattern = checkRegexInput[key];

        if (pattern) {
            // allow empty to permit deletion/backspace
            if (newValue !== "" && !pattern.test(String(newValue))) {
                return; // invalid input for this key, do not update state
            }
        }
        
        if (copyMandatoryFields[key]) {
            copyMandatoryFields[key] = false;
            setMandatoryFields({ ...copyMandatoryFields })
        }
        setPrixDetailsLocal(prevData => ({
            ...prevData,
            [key]: newValue
        }));
    };
    const blackOutDates = {
        fromDate: null,
        toDate: null,
        aller: undefined,
        retour: undefined,
        exceptionType: ''
    }

    const blackOutDays = {
        day: '',
        aller: undefined,
        retour: undefined,
        exceptionType: ''
    }

    const blackOutCarrier = {
        carrierCode: '',
        flightNumberFrom: '',
        flightNumberTo: '',
        aller: undefined,
        retour: undefined,
        exceptionType: '',
        isMarkedForDelete: false
    }

    const tourCode = {
        tourCodes: "",
        marketCode: "",
        passengerType: []
    }

      const blackOutCarrierCTA = async (action, index = 0, extraValue = null) => {
        if(action === BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT && !extraValue) {
            return;
        }
        if(action === BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT) {
          const regex = /^([A-Z0-9]{2})\s+(\d{1,8}(?:-\d{1,8})?(?:\s*,\s*\d{1,8}(?:-\d{1,8})?)*)$/;
            const match = extraValue.match(regex);
            if(!match){
              swal({
                title: "Error",
                text: "Please provide a valid display text.(e.g. AC 1234-5678, 2345)",
                icon: "error",
                button: "OK",
              });
              return;
            }
        }

        if(action === BLACKOUT_CARRIER_ACTION.DELETE_INDEX ) {
            let payload = { ...nestedPayload };
            let [key, value] = Object.entries(payload)[0];
            value.splice(index, 1);
            let modifiedPayload = { [key]: value };
            setNestedPayload(modifiedPayload);
            console.log("=>>updatedPayload", modifiedPayload);
            return;
        }
    
        const updatedPayload = applyAction(nestedPayload, action, index, extraValue, prixDetailsLocal.blackOutCarrier);
        setNestedPayload(updatedPayload);
        const [data] = Object.values(updatedPayload);
        if (data) {
        setPrixDetailsLocal(prev => ({
            ...prev,
            blackOutCarrier: data
        }));
        }
        // const reverseBlackoutpayload = reverseBlackOutCarrierPayload(updatedPayload);
        console.log("=>>updatedPayload", updatedPayload);
      };

    const savePrix = async () => {
        setUpdateLoader(true)
        let clasData = {
            prixClasKey: classValues?.clasKey,
        }
        const payload = [{ ...prixDetailsLocal, ...clasData, "prixKey": prixDetailsLocal?.prixKey ? prixDetailsLocal?.prixKey : undefined }]

        // const finalPrixData = filterObject(convertPropertiesToArray(payload)?.prixData, keysToKeep)
        // const finalPayload = {...payload,["tarifData"]:finalTarifData}
        const cleanedObj = cleanObject(payload[0]);

        // Check if all mandatory fields are entered;
        let copyMandatoryFields = { ...mandatoryFields };
        Object.keys(copyMandatoryFields).forEach((field) => {
            copyMandatoryFields[field] = prixDetailsLocal[field]?.length && prixDetailsLocal[field]?.length > 0 ? false : true;
        });
        setMandatoryFields({ ...copyMandatoryFields })
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }

        if(prixDetailsLocal.blackOutCarrier?.length > 0 || Object.values(nestedPayload)?.length > 0) {
            const reverseBlackoutpayload = reverseBlackOutCarrierPayload(nestedPayload);
            payload[0].blackOutCarrier = Object.values(reverseBlackoutpayload)?.[0] || [];
        }
        if (prixDetailsLocal?.tourCode?.length > 0) {
            const output = prixDetailsLocal?.tourCode?.flatMap(item =>
                item?.passengerType?.map(type => ({
                    tourCodes: item?.tourCodes,
                    marketCode: item?.marketCode,
                    passengerType: type
                }))
            );
            payload[0].tourCode = output;
        }
        if(classValues?.contractType == "Published") {
            if (prixDetailsLocal?.commissionPercentage?.length > 0 && prixDetailsLocal?.commissionPercentage?.charAt(0) !== '+' && prixDetailsLocal?.commissionPercentage?.charAt(0) !== '-') {
                payload[0].commissionPercentage = '-' + prixDetailsLocal?.commissionPercentage
            }
            if (prixDetailsLocal?.childCommissionPercentage?.length > 0 && prixDetailsLocal?.childCommissionPercentage?.charAt(0) !== '+' && prixDetailsLocal?.childCommissionPercentage?.charAt(0) !== '-') {
                payload[0].childCommissionPercentage = '-' + prixDetailsLocal?.childCommissionPercentage
            }
            if (prixDetailsLocal?.infantCommissionPercentage?.length > 0 && prixDetailsLocal?.infantCommissionPercentage?.charAt(0) !== '+' && prixDetailsLocal?.infantCommissionPercentage?.charAt(0) !== '-') {
                payload[0].infantCommissionPercentage = '-' + prixDetailsLocal?.infantCommissionPercentage
            }
        //     if (prixDetailsLocal?.passBackCommission?.length > 0 && prixDetailsLocal?.passBackCommission?.charAt(0) !== '+' && prixDetailsLocal?.passBackCommission?.charAt(0) !== '-') {
        //         payload[0].passBackCommission = '-' + prixDetailsLocal?.passBackCommission
        //     }
        } else if (classValues?.contractType == "Net") {
            payload[0].commissionPercentage = '+$0';
            payload[0].childCommissionPercentage = '0%';
            payload[0].infantCommissionPercentage = '0%';
            payload[0].passBackCommission = null;
            payload[0].childPassBackCommission = null;
            payload[0].infantPassBackCommission = null;
        }
        const bulkUpdateResponse = await upsertNewPrix(payload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: createNew ? "Prix created successfully!" : "Prix updated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newPrix?tariff=${URLTarifKey}&class=${URLClassKey}&prix=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }
    }

    const createNewPrix = () => {
        console.log('New Prix is created! ', prixDetailsLocal)
    }

    const CreateMultiplePrixs = () => {
        createNewPrix();
    }

    const removeNullProperties = (obj) => {
        const cleanedObj = {};
        for (const key in obj) {
            if (obj[key] !== null && obj[key] !== undefined) {
                cleanedObj[key] = obj[key];
            }
        }
        return cleanedObj;
    }

    const formatToESTDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth();
        const day = date.getUTCDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${day}-${monthNames[month]}-${year}`;
    }

    function cleanObject(obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj
                .map(cleanObject)
                .filter(item => item !== null && item !== undefined && item !== ""); // Remove unwanted items
        }

        const cleanedObj = {};

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                if (value !== null && value !== undefined && value !== "") {
                    cleanedObj[key] = cleanObject(value);
                }
            }
        }

        return cleanedObj;
    }

    const tariffKeyRef = useRef(URLTarifKey);
    const classKeyRef = useRef(URLClassKey);
    const prixKeysRef = useRef(URLPrixKey);

    useEffect(() => {
        classKeyRef.current = URLClassKey;
        tariffKeyRef.current = URLTarifKey;
        prixKeysRef.current = URLPrixKey;

    }, [URLClassKey,URLTarifKey, URLPrixKey]);

    const handleNextClass = async() => {
        if (prixKeysRef.current && (!createNew)) {
            let currentIndex = prixKeys.findIndex(item => item == prixKeysRef.current);
            const nextIndex = currentIndex + 1;
            if (prixKeys[nextIndex]) {
                let newPrixKey = prixKeys[nextIndex];
                const response = await getcontracts({ "prixKey": newPrixKey.trim() })
                let tarifKey = response?.tarifs[0]?.tarifKey;
                let classKey = response?.tarifs[0]?.classes[0]?.clasKey;
                if (newPrixKey && tarifKey && classKey) {
                    history.push(`/newPrix?tariff=${tarifKey}&class=${classKey}&prix=${newPrixKey}`);
                }
            }
        }
    };

    const handlePreviousClass = async() => {
        if (prixKeysRef.current && (!createNew)) {

            let currentIndex = prixKeys.findIndex(item => item == prixKeysRef.current);
            const prevIndex = currentIndex - 1;
            if (prixKeys[prevIndex]) {
                let newPrixKey = prixKeys[prevIndex];
                const response = await getcontracts({ "prixKey": newPrixKey.trim() })
                let tarifKey = response?.tarifs[0]?.tarifKey;
                let classKey = response?.tarifs[0]?.classes[0]?.clasKey;
                if (newPrixKey && tarifKey && classKey) {
                    history.push(`/newPrix?tariff=${tarifKey}&class=${classKey}&prix=${newPrixKey}`);
                }
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === "ArrowRight") {
                event.preventDefault();
                handleNextClass();
            } else if (event.ctrlKey && event.key === "ArrowLeft") {
                event.preventDefault();
                handlePreviousClass();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const createDuplicate = async () => {
        if (updateLoader) return;
        setUpdateLoader(true)
        let clasData = {
            prixClasKey: classValues?.clasKey,
        }
        const payload = [{ ...prixDetailsLocal, ...clasData, "prixKey": undefined }]

        // Check if all mandatory fields are entered;
        let copyMandatoryFields = { ...mandatoryFields };
        Object.keys(copyMandatoryFields).forEach((field) => {
            copyMandatoryFields[field] = prixDetailsLocal[field]?.length && prixDetailsLocal[field]?.length > 0 ? false : true;
        });
        setMandatoryFields({ ...copyMandatoryFields })
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }
        if (prixDetailsLocal?.tourCode?.length > 0) {
            const output = prixDetailsLocal?.tourCode?.flatMap(item =>
                item?.passengerType?.map(type => ({
                    tourCodes: item?.tourCodes,
                    marketCode: item?.marketCode,
                    passengerType: type
                }))
            );
            payload[0].tourCode = output;
        }
        const bulkUpdateResponse = await upsertNewPrix(payload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: "Prix duplicated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newPrix?tariff=${URLTarifKey}&class=${URLClassKey}&prix=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }

    }

    console.log("prixDetailsLocal", prixDetailsLocal)
    return (
        <>
        {loader ?
            <div className="col-md-12 text-center mt-3">
                <SpinnerLoader />
            </div>
            :
        <>
            <div className="cm-head-2 ">
                <div className={"d-flex justify-content-between"}>
                    <div className='d-flex '>
                        <h5 className="">
                            {createNew ? 'Create Prix' : !disableEdit ?
                                <>
                                    Edit Prix
                                </>
                                :
                                <>
                                    Prix Details
                                </>
                            }

                        </h5>&nbsp;&nbsp;
                        <span className="d-flex justify-content-between">
                            {(!createNew && (disableEdit)) && <i className="fas fa-edit" style={{ "color": "#0055b8", "cursor": "pointer" }} onClick={() => setDisableEdit(!disableEdit)}></i>}
                            {/* {(!createNew) &&
                                <span title="Create a Duplicate Prix">
                                    <i class="fa-solid fa-copy" style={{ "color": "#0055b8", "cursor": "pointer", "marginLeft": "10px" }} onClick={() => createDuplicate()}></i>
                                </span>
                            } */}
                        </span>
                    </div>

                    <div>
                        {createNew ?
                            <>
                                Class: <a style={{ "textDecoration": "underline" }} onClick={() => history.push(`/newClass?tariff=${tarifValues?.tarifKey}+&class=${classValues?.clasKey}`)}>{classValues?.clasKey}</a>&nbsp;  Tariff : <a style={{ "textDecoration": "underline" }} onClick={() => history.push(`/newTariff?tariff=${tarifValues?.tarifKey}`)}>{tarifValues?.tarifKey}</a>
                            </>
                            :
                            <>
                                Prix:{prixDetailsLocal?.prixKey} &nbsp;Class: <a style={{ "textDecoration": "underline" }} onClick={() => history.push(`/newClass?tariff=${tarifValues?.tarifKey}+&class=${classValues?.clasKey}`)}>{classValues?.clasKey}</a>&nbsp;  Tariff : <a style={{ "textDecoration": "underline" }} onClick={() => history.push(`/newTariff?tariff=${tarifValues?.tarifKey}`)}>{tarifValues?.tarifKey}</a>
                            </>
                        }
                    </div>
                </div>

            </div> 
            
            <div className="Tariff__Section Prix__section">
                <div >
                    <div className="card Tariff__BorderB">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Carrier</label>
                                            <label>{tarifData?.carrier}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.carrier}
                                                disabled={true}
                                                name='Carrier'
                                                label="Carrier"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Origin</label>
                                            <label>{tarifData?.origins}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.origins}
                                                disabled={true}
                                                name='Origin'
                                                label="Origin"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Destination</label>
                                            <label>{tarifData?.destinations}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.destinations}
                                                disabled={true}
                                                name='Destination'
                                                label="Destination"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Trip Type</label>
                                            <label>{tarifValues?.tripType == "OW" ? "One Way" : "Not One Way"}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.tripType == "OW" ? "One Way" : "Not One Way"}
                                                disabled={true}
                                                name='Trip Type'
                                                label="Trip Type"
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Contract Type</label>
                                            <label>{tarifValues.cruiseFare == 1 ? "Cruise" : tarifValues.landFare == 1 ? "Land" : "Air"}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.cruiseFare == 1 ? "Cruise" : tarifValues?.landFare == 1 ? "Land" : "Air"}
                                                disabled={true}
                                                name='Contract Type'
                                                label="Contract Type"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Fare Type</label>
                                            <label>{classData?.contractType}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={classValues?.contractType}
                                                disabled={true}
                                                name='Fare Type'
                                                label="Fare Type"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Branded Fare</label>
                                            <label>{tarifData?.isBrandedFare == 1 ? "Yes" : "No"}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.isBrandedFare == 1 ? "Yes" : "No"}
                                                disabled={true}
                                                name='Branded Fare'
                                                label="Branded Fare"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Cabin Type</label>
                                            <label>{tarifValues.cabinType?.join(', ')}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.cabinType?.join(', ')}
                                                disabled={true}
                                                name='Cabin Type'
                                                label="Cabin Type"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Classes</label>
                                            <label>{classData?.classCodes?.join(', ')}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={classValues?.classCodes?.join(', ')}
                                                disabled={true}
                                                name='Classes'
                                                label="Classes"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Brand</label>
                                            <label>{classData?.brandCode}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={classValues?.brandCode}
                                                disabled={true}
                                                name='Brand'
                                                label="Brand"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Ticketing Fee</label>
                                            <label>{classData?.ticketingFee}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={classValues?.ticketingFee}
                                                disabled={true}
                                                name='Ticketing Fee'
                                                label="Ticketing Fee"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">EDR Date</label>
                                            <label>{moment.utc(classData?.classLastTicketingDate).format("YYYY-MM-DD")}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={moment.utc(classValues?.classLastTicketingDate).format("YYYY-MM-DD")}
                                                disabled={true}
                                                name='EDR Date'
                                                label="EDR Date"
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="row mt-4">
                                <div className="col-md-6 cm-col">
                                    <div className="row">
                                        {/* {!createNew && <div className="col-md-6">
                                            <label className="cm-head-label">Prix Key</label>

                                            <TextField label=''
                                                className="form-control cm-input autoCapitalise custom-disabled-field"
                                                placeholder="Enter Class Key"
                                                value={prixDetailsLocal?.prixKey}
                                                disabled={true}
                                                name='prixKey'
                                                
                                            />
                                        </div>} */}
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Valid From <span className='bd-errorMsg'>*</span></label> */}

                                            <CustomDateInput
                                                value={prixDetailsLocal?.validFrom}
                                                onChange={(date) => commonOnChange('validFrom', date)}
                                                disabled={disableEdit}
                                                minDate={new Date('2024-01-01')}
                                                // maxDate={todaysDate}
                                                className='col-md-6 custom-disabled-field'
                                                label="Valid From"
                                                required={true}
                                            />
                                            {mandatoryFields?.validFrom &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Valid To <span className='bd-errorMsg'>*</span></label> */}
                                            <CustomDateInput
                                                value={prixDetailsLocal?.validTo}
                                                onChange={(date) => commonOnChange('validTo', date)}
                                                disabled={disableEdit}
                                                // maxDate={maxDate}
                                                className="BulkUpdate__DateInput custom-disabled-field"
                                                label="Valid To"
                                                required={true}
                                            />
                                            {mandatoryFields?.validTo &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-6 cm-col">

                                    <div className="row">

                                        <div className="col-md-6">

                                            {/* <label className="cm-head-label">Last Ticketing Date <span className='bd-errorMsg'>*</span></label> */}
                                            {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    className='BulkUpdate__DatePicker'
                                                    format="dd MMM yyyy"
                                                    value={prixDetailsLocal?.prixLastTicketingDate ? moment(new Date(prixDetailsLocal?.prixLastTicketingDate)).format("DD-MMM-yyyy") : null}
                                                    onChange={(e) => { commonOnChange('prixLastTicketingDate', format(e, 'yyyy-MM-dd') ); }}
                                                    disabled={disableEdit}  
                                                />
                                            </MuiPickersUtilsProvider> */}
                                            <CustomDateInput
                                                value={prixDetailsLocal?.prixLastTicketingDate}
                                                onChange={(date) => commonOnChange('prixLastTicketingDate', date)}
                                                disabled={disableEdit}
                                                className="BulkUpdate__DateInput custom-disabled-field"
                                                label="Last Ticketing Date"
                                                
                                            />
                                            {/* {mandatoryFields?.prixLastTicketingDate &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            } */}
                                        </div>
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Last Return Date</label>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker className='BulkUpdate__DatePicker' format="dd MMM yyyy" value={prixDetailsLocal?.prixLastReturnDate ? moment(new Date(prixDetailsLocal?.prixLastReturnDate)).format("DD-MMM-yyyy") : null} onChange={(e) => { commonOnChange('prixLastReturnDate', format(e, 'yyyy-MM-dd')); }} disabled={disableEdit} />
                                            </MuiPickersUtilsProvider> */}
                                            <CustomDateInput
                                                value={prixDetailsLocal?.prixLastReturnDate}
                                                onChange={(date) => commonOnChange('prixLastReturnDate', date)}
                                                disabled={disableEdit}
                                                className="BulkUpdate__DateInput custom-disabled-field"
                                                label="Last Return Date"
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">

                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Prix Note</label> */}
                                            <TextField label='Prix Note' className="form-control cm-input autoCapitalise custom-disabled-field" placeholder="Enter Note" value={prixDetailsLocal?.prixNote} onChange={(e) => { commonOnChange('prixNote', e?.target?.value?.toUpperCase()) }} disabled={disableEdit} inputProps={{ maxLength: 20 }}/>
                                        </div>

                                    </div>
                                </div>

                                {/* <div className="col-md-6"> 
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label"></label>
                                        <FormControlLabel control={<Checkbox checked={Boolean(prixDetailsLocal?.noTKTBY)} onChange={() => commonOnChange('noTKTBY', !Boolean(prixDetailsLocal?.noTKTBY))} />} label="No TKT-BY" disabled={disableEdit} />
                                    </div>
                                    </div> */}
                            </div>


                        </div>
                    </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 20, borderColor: '#E1F0FF', background: '#fff' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Prix" value="1" />
                                    <Tab label="Exception" value="2" />
                                    <Tab label="Emission (Segments)" value="3" />
                                </TabList>
                            </Box>
                            <TabPanel value="1" className='m-0 p-0'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_adult} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                            <TextField 
                                                                label='OUR COMMISSION' 
                                                                className="form-control cm-input autoCapitalise custom-disabled-field" 
                                                                type="text" 
                                                                placeholder='Enter %' 
                                                                value={prixDetailsLocal?.commissionPercentage} 
                                                                onChange={(e) => { commonOnChange('commissionPercentage', e?.target?.value?.toUpperCase()) }} 
                                                                disabled={disableEdit || disableOurCommissionForAdult} 
                                                                required={classValues?.contractType == "Published"}
                                                            />

                                                        </div>
                                                        {mandatoryFields?.commissionPercentage &&
                                                            <div className='bd-errorMsg'>This field is required.</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR MARKUP</label> */}
                                                            <TextField 
                                                                label='OUR MARKUP' 
                                                                className="form-control cm-input" 
                                                                placeholder='Enter $' 
                                                                value={prixDetailsLocal?.markup} 
                                                                onChange={(e) => { commonOnChange('markup', e?.target?.value?.toUpperCase()) }} 
                                                                disabled={disableEdit || disableOurMarkupForAdult} 
                                                                required={classValues?.contractType == "Net"}
                                                            />
                                                        </div>
                                                        {mandatoryFields?.markup &&
                                                            <div className='bd-errorMsg'>This field is required.</div>
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label"> AGENCY COMMISSION</label> */}
                                                            <TextField
                                                                fullWidth
                                                                label="AGENCY COMMISSION"
                                                                className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field"
                                                                type="text"
                                                                placeholder="Enter %"
                                                                value={prixDetailsLocal?.passBackCommission}
                                                                onChange={(e) => commonOnChange('passBackCommission', e?.target?.value?.toUpperCase())}
                                                                disabled={disableEdit || disableAgencyCommissionForAdult}
                                                                required={classValues?.contractType == "Published"}
                                                            />
                                                        </div>
                                                        {mandatoryFields?.passBackCommission &&
                                                            <div className='bd-errorMsg'>This field is required.</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">MIN SELL</label> */}
                                                            <TextField label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={prixDetailsLocal?.minumumSellingPrice} onChange={(e) => { commonOnChange('minumumSellingPrice', e?.target?.value) }} disabled={disableEdit} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_child} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                            <TextField 
                                                                label='OUR COMMISSION' 
                                                                className="form-control cm-input autoCapitalise custom-disabled-field" 
                                                                type="text" 
                                                                placeholder='Enter %' 
                                                                value={prixDetailsLocal?.childCommissionPercentage} 
                                                                onChange={(e) => { commonOnChange('childCommissionPercentage', e?.target?.value?.toUpperCase()) }} 
                                                                disabled={disableEdit || disableOurCommissionForChild} 
                                                                required={classValues?.contractType == "Published"}
                                                            />
                                                            {mandatoryFields?.childCommissionPercentage &&
                                                                <div className='bd-errorMsg'>This field is required.</div>
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR MARKUP</label> */}
                                                            <TextField 
                                                                label='OUR MARKUP' 
                                                                className="form-control cm-input autoCapitalise custom-disabled-field" 
                                                                type="text" 
                                                                placeholder='Enter $' 
                                                                value={prixDetailsLocal?.childMarkUp?.toUpperCase()} 
                                                                onChange={(e) => { commonOnChange('childMarkUp', e?.target?.value) }} 
                                                                disabled={disableEdit || disableOurMarkupForChild} 
                                                                required={classValues?.contractType == "Net"}
                                                            />
                                                        </div>
                                                        {mandatoryFields?.childMarkUp &&
                                                            <div className='bd-errorMsg'>This field is required.</div>
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label"> AGENCY COMMISSION</label> */}
                                                            <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.childPassBackCommission} onChange={(e) => { commonOnChange('childPassBackCommission', e?.target?.value?.toUpperCase()) }} disabled={disableEdit || disableAgencyCommissionForChild} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">MIN SELL</label> */}
                                                            <TextField label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={prixDetailsLocal?.minumumSellingPrice} onChange={(e) => { commonOnChange('minumumSellingPrice', e?.target?.value) }} disabled={disableEdit} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_childfriendly} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                            <TextField
                                                                label='OUR COMMISSION'
                                                                className="form-control cm-input autoCapitalise custom-disabled-field"
                                                                type="text"
                                                                placeholder='Enter %'
                                                                value={prixDetailsLocal?.infantCommissionPercentage}
                                                                onChange={(e) => { commonOnChange('infantCommissionPercentage', e?.target?.value?.toUpperCase()) }}
                                                                disabled={disableEdit || disableOurCommissionForInfant}
                                                                required={classValues?.contractType == "Published"}
                                                            />
                                                            {mandatoryFields?.infantCommissionPercentage &&
                                                                <div className='bd-errorMsg'>This field is required.</div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">OUR MARKUP</label> */}
                                                            <TextField 
                                                                label='OUR MARKUP' 
                                                                className="form-control cm-input autoCapitalise custom-disabled-field" 
                                                                type="text" 
                                                                placeholder='Enter $' 
                                                                value={prixDetailsLocal?.infantMarkUp} 
                                                                onChange={(e) => { commonOnChange('infantMarkUp', e?.target?.value?.toUpperCase()) }} 
                                                                disabled={disableEdit || disableOurMarkupForInfant}
                                                                required={classValues?.contractType == "Net"} 
                                                            />
                                                        </div>
                                                        {mandatoryFields?.infantMarkUp &&
                                                            <div className='bd-errorMsg'>This field is required.</div>
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label"> AGENCY COMMISSION</label> */}
                                                            <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.infantPassBackCommission} onChange={(e) => { commonOnChange('infantPassBackCommission', e?.target?.value?.toUpperCase()) }} disabled={disableEdit || disableAgencyCommissionForInfant} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            {/* <label className="cm-head-label">MIN SELL</label> */}
                                                            <TextField label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={prixDetailsLocal?.minumumSellingPrice} onChange={(e) => { commonOnChange('minumumSellingPrice', e?.target?.value) }} disabled={disableEdit} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className=" cm-head-2 mb-4 mr-8">
                                                    <div className="d-flex justify-content-between">
                                                        <span className="">Navcan (Surcharges)</span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_adult} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.adultCommissionOnYQNav} onChange={(e) => { commonOnChange('adultCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.adultPassBackCommissionOnYQNav} onChange={(e) => { commonOnChange('adultPassBackCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>
                                                <div className=" cm-head-2 mb-4">
                                                    <div className="d-flex justify-content-between">
                                                        <span className="">Carburant</span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_adult} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.adultCommissionOnYQ} onChange={(e) => { commonOnChange('adultCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.adultPassBackCommissionOnYQ} onChange={(e) => { commonOnChange('adultPassBackCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_child} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.childCommissionOnYQNav} onChange={(e) => { commonOnChange('childCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.childPassBackCommissionOnYQNav} onChange={(e) => { commonOnChange('childPassBackCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>

                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_child} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.childCommissionOnYQ} onChange={(e) => { commonOnChange('childCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.childPassBackCommissionOnYQ} onChange={(e) => { commonOnChange('childPassBackCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_childfriendly} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.enfantCommissionOnYQNav} onChange={(e) => { commonOnChange('enfantCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.enfantPassBackCommissionOnYQNav} onChange={(e) => { commonOnChange('enfantPassBackCommissionOnYQNav', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>

                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_childfriendly} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">OUR COMMISSION</label> */}
                                                                    <TextField label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.enfantCommissionOnYQ} onChange={(e) => { commonOnChange('enfantCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">AGENCY COMMISSION</label> */}
                                                                    <TextField label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={prixDetailsLocal?.enfantPassBackCommissionOnYQ} onChange={(e) => { commonOnChange('enfantPassBackCommissionOnYQ', e?.target?.value) }} disabled={disableEdit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>








                            </TabPanel>

                            <TabPanel value="2" className='m-0 p-0'>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Blackout Dates</span>
                                            </div>
                                        </div>
                                        {prixDetailsLocal?.blackOutDates?.length ? prixDetailsLocal?.blackOutDates?.map((blackOutDateValue, index) => {
                                            return (<>
                                                <div key={index} className="row">
                                                    <div className="col-md-3 cm-col">
                                                        <CustomDateInput
                                                            value={blackOutDateValue.fromDate ? blackOutDateValue.fromDate : null}
                                                            onChange={(formattedDate) => {
                                                                const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                    idx === index ? { ...item, fromDate: formattedDate } : item
                                                                );
                                                                commonOnChange('blackOutDates', updatedBlackOutDates);
                                                            }}
                                                            disabled={disableEdit}
                                                            label="Start Date"
                                                            className="BulkUpdate__DateInput"
                                                        />
                                                    </div>
                                                    <div className="col-md-3 cm-col">
                                                        {/* <label className="cm-head-label">End Date </label> */}
                                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    {/* <KeyboardDatePicker className='BulkUpdate__DatePicker' format="dd MMM yyyy" value={blackOutDateValue.toDate} onChange={() => { }} disabled={disableEdit}/> */}
                                                        {/* <KeyboardDatePicker
                                                            className='BulkUpdate__DatePicker'
                                                            format="dd MMM yyyy"
                                                            value={blackOutDateValue.toDate ? formatToESTDate(blackOutDateValue.toDate) : null}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    const toDate = format(date, 'yyyy-MM-dd');;
                                                                    const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                        idx === index ? { ...item, toDate: toDate } : item
                                                                    );
                                                                    commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                }
                                                            }}
                                                            disabled={disableEdit}
                                                        />
                                                </MuiPickersUtilsProvider> */}
                                                        <CustomDateInput
                                                            value={blackOutDateValue.toDate ? blackOutDateValue.toDate : null}
                                                            onChange={(formattedDate) => {
                                                                const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                    idx === index ? { ...item, toDate: formattedDate } : item
                                                                );
                                                                commonOnChange('blackOutDates', updatedBlackOutDates);
                                                            }}
                                                            disabled={disableEdit}
                                                            label="End Date"
                                                            className="BulkUpdate__DateInput"
                                                        />

                                                    </div>

                                                    <div className="col-md-3">
                                                        <label className="cm-head-label"> </label>

                                                        <div className="row custom-disabled-field">
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={Boolean(blackOutDateValue.aller)} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const aller = e?.target?.checked;
                                                                            const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                                idx === index ? { ...item, aller: aller } : item
                                                                            );
                                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                        }
                                                                    }}
                                                                />} label="Departure" />
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={Boolean(blackOutDateValue.retour)} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const retour = e?.target?.checked;
                                                                            const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                                idx === index ? { ...item, retour: retour } : item
                                                                            );
                                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                        }
                                                                    }}
                                                                />} label="Return" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 cm-col">
                                                        <label className="cm-head-label">Exception Type</label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <Select className='BulkUpdate__DatePicker' value={blackOutDateValue.exceptionType} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const exceptionType = e?.target?.value;
                                                                            const updatedBlackOutDates = prixDetailsLocal?.blackOutDates.map((item, idx) =>
                                                                                idx === index ? { ...item, exceptionType: exceptionType } : item
                                                                            );
                                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                        }
                                                                    }}
                                                                >
                                                                    <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                                                    <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                                                    <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                                                </Select>
                                                            </div>
                                                            <div className="col-md-3">
                                                                {(!disableEdit) &&
                                                                    <div className='setD-flex'>
                                                                        <Button
                                                                            className="BulkUpdate__removeBtn"
                                                                            disabled={disableEdit || prixDetailsLocal?.blackOutDates?.length === 0}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutDates?.length > 0) {
                                                                                    // Create a new array excluding the item at the current index
                                                                                    const updatedBlackOutDates = prixDetailsLocal.blackOutDates.filter((_, i) => i !== index);
                                                                                    commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </Button>


                                                                        <Button
                                                                            className='BulkUpdate__AddBtn'
                                                                            disabled={disableEdit}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutDates?.length > 0) {
                                                                                    const updatedBlackOutDates = [...prixDetailsLocal.blackOutDates, blackOutDates];
                                                                                    commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-plus-circle"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></>
                                            )
                                        }) : <>
                                            <div className="row">
                                                <div className="col-md-3 cm-col">
                                                    {/* <label className="cm-head-label">Start Date </label> */}
                                                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                className='BulkUpdate__DatePicker'
                                                                format="dd MMM yyyy"
                                                                value={null}
                                                                onChange={(date) => {
                                                                    if (date) {
                                                                        const fromDate = format(date, 'yyyy-MM-dd');;
                                                                        const updatedBlackOutDates = [{ ...blackOutDates, fromDate: fromDate }];
                                                                        commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                    }
                                                                }}
                                                                disabled={disableEdit}
                                                            />
                                                </MuiPickersUtilsProvider> */}
                                                    <CustomDateInput
                                                        value={null}
                                                        onChange={(formattedDate) => {
                                                            const updatedBlackOutDates = [{ ...blackOutDates, fromDate: formattedDate }];
                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                        }}
                                                        disabled={disableEdit}
                                                        label="Start Date"
                                                        className="BulkUpdate__DateInput"
                                                    />

                                                </div>
                                                <div className="col-md-3 cm-col">
                                                    {/* <label className="cm-head-label">End Date </label>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker className='BulkUpdate__DatePicker' format="dd MMM yyyy" disabled={disableEdit} value={null} 
                                                    onChange={(date) => {
                                                        if (date) {
                                                            const toDate = format(date, 'yyyy-MM-dd');;
                                                            const updatedBlackOutDates = [{ ...blackOutDates, toDate: toDate }];
                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                        }
                                                    }}
                                                    />
                                                </MuiPickersUtilsProvider> */}
                                                    <CustomDateInput
                                                        value={null}
                                                        onChange={(formattedDate) => {
                                                            const updatedBlackOutDates = [{ ...blackOutDates, toDate: formattedDate }];
                                                            commonOnChange('blackOutDates', updatedBlackOutDates);
                                                        }}
                                                        disabled={disableEdit}
                                                        label="End Date"
                                                        className="BulkUpdate__DateInput"
                                                    />

                                                </div>

                                                <div className="col-md-3">
                                                    <label className="cm-head-label"> </label>

                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-6">
                                                            <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit}
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const aller = e?.target?.checked;
                                                                        const updatedBlackOutDates = [{ ...blackOutDates, aller: aller }];
                                                                        commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                    }
                                                                }}
                                                            />} label="Departure" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit}
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const retour = e?.target?.checked;
                                                                        const updatedBlackOutDates = [{ ...blackOutDates, retour: retour }];
                                                                        commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                    }
                                                                }}
                                                            />} label="Return" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 cm-col">
                                                    <label className="cm-head-label">Exception Type</label>
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <Select className='BulkUpdate__DatePicker' disabled={disableEdit}
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const exceptionType = e?.target?.value;
                                                                        const updatedBlackOutDates = [{ ...blackOutDates, exceptionType: exceptionType }];
                                                                        commonOnChange('blackOutDates', updatedBlackOutDates);
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value={10}>Ten</MenuItem>
                                                                <MenuItem value={20}>Twenty</MenuItem>
                                                                <MenuItem value={30}>Thirty</MenuItem>
                                                            </Select>
                                                        </div>
                                                        <div className="col-md-3">
                                                            {(!disableEdit) &&
                                                                <div className='setD-flex'>
                                                                    <Button className="BulkUpdate__removeBtn" disabled={true} ><i className="fas fa-trash-alt"></i></Button>
                                                                    <Button className='BulkUpdate__AddBtn' disabled={disableEdit} onClick={() => { if (prixDetailsLocal?.blackOutDates?.length == 0) { commonOnChange('blackOutDates', [blackOutDates, blackOutDates]) } }}><i className="fas fa-plus-circle"></i></Button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></>
                                        }
                                    </div>
                                </div>


                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Blackout Days</span>
                                            </div>
                                        </div>
                                        {prixDetailsLocal?.blackOutDays?.length ? prixDetailsLocal?.blackOutDays?.map((blackOutDayValue, index) => {
                                            return (<>
                                                <div className="row">
                                                    <div className="col-md-3 cm-col">
                                                        {/* <label className="cm-head-label">Days </label> */}
                                                        <TextField label='Days' className="form-control cm-input autoCapitalise custom-disabled-field" value={blackOutDayValue?.day} disabled={disableEdit}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    const day = e?.target?.value?.toUpperCase();
                                                                    const updatedBlackOutDays = prixDetailsLocal?.blackOutDays.map((item, idx) =>
                                                                        idx === index ? { ...item, day: day } : item
                                                                    );
                                                                    commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                }
                                                            }}
                                                        />
                                                    </div>


                                                    <div className="col-md-3">
                                                        <label className="cm-head-label"> </label>

                                                        <div className="row custom-disabled-field">
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={Boolean(blackOutDayValue?.aller)} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const aller = e?.target?.checked;
                                                                            const updatedBlackOutDays = prixDetailsLocal?.blackOutDays.map((item, idx) =>
                                                                                idx === index ? { ...item, aller: aller } : item
                                                                            );
                                                                            commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                        }
                                                                    }}
                                                                />} label="Departure" />
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={Boolean(blackOutDayValue?.retour)} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const retour = e?.target?.checked;
                                                                            const updatedBlackOutDays = prixDetailsLocal?.blackOutDays.map((item, idx) =>
                                                                                idx === index ? { ...item, retour: retour } : item
                                                                            );
                                                                            commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                        }
                                                                    }}
                                                                />} label="Return" />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 cm-col">
                                                        <label className="cm-head-label">Exception Type</label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <Select className='BulkUpdate__DatePicker' value={blackOutDayValue?.exceptionType} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const exceptionType = e?.target?.value;
                                                                            const updatedBlackOutDays = prixDetailsLocal?.blackOutDays.map((item, idx) =>
                                                                                idx === index ? { ...item, exceptionType: exceptionType } : item
                                                                            );
                                                                            commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                        }
                                                                    }}
                                                                >
                                                                    <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                                                    <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                                                    <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                                                </Select>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 cm-col">
                                                        <label className="cm-head-label"> </label>
                                                        <div className="row">
                                                            <div className="col-md-7">

                                                            </div>
                                                            <div className="col-md-3">
                                                                {(!disableEdit) &&
                                                                    <div className='setD-flex'>
                                                                        <Button
                                                                            className="BulkUpdate__removeBtn"
                                                                            disabled={disableEdit || prixDetailsLocal?.blackOutDays?.length === 0}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutDays?.length > 0) {
                                                                                    // Create a new array excluding the item at the current index
                                                                                    const updatedBlackOutDays = prixDetailsLocal.blackOutDays.filter((_, i) => i !== index);
                                                                                    commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </Button>

                                                                        <Button
                                                                            className='BulkUpdate__AddBtn'
                                                                            disabled={disableEdit}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutDays?.length > 0) {
                                                                                    const updatedBlackOutDays = [...prixDetailsLocal.blackOutDays, blackOutDays];
                                                                                    commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-plus-circle"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)
                                        }) : <>
                                            <div className="row">
                                                <div className="col-md-3 cm-col">
                                                    {/* <label className="cm-head-label">Days </label> */}
                                                    <TextField label='Days' className="form-control cm-input autoCapitalise custom-disabled-field" disabled={disableEdit}
                                                        onChange={(e) => {
                                                            if (e) {
                                                                const day = e?.target?.value?.toUpperCase();
                                                                const updatedBlackOutDays = [{ ...blackOutDays, day: day }];
                                                                commonOnChange('blackOutDays', updatedBlackOutDays);
                                                            }
                                                        }}
                                                    />
                                                </div>


                                                <div className="col-md-3">
                                                    <label className="cm-head-label"> </label>

                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit} />} label="Departure"
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const aller = e?.target?.checked;
                                                                        const updatedBlackOutDays = [{ ...blackOutDays, aller: aller }];
                                                                        commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit} />} label="Return"
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const retour = e?.target?.checked;
                                                                        const updatedBlackOutDays = [{ ...blackOutDays, retour: retour }];
                                                                        commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                    }
                                                                }}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-md-3 cm-col">
                                                    <label className="cm-head-label">Exception Type</label>
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <Select className='BulkUpdate__DatePicker' disabled={disableEdit}
                                                                onChange={(e) => {
                                                                    if (e) {
                                                                        const exceptionType = e?.target?.value;
                                                                        const updatedBlackOutDays = [{ ...blackOutDays, exceptionType: exceptionType }];
                                                                        commonOnChange('blackOutDays', updatedBlackOutDays);
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                                                <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                                                <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                                            </Select>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-md-3 cm-col">
                                                    <label className="cm-head-label"> </label>
                                                    <div className="row">
                                                        <div className="col-md-7">

                                                        </div>
                                                        <div className="col-md-3">
                                                            {(!disableEdit) &&
                                                                <div className='setD-flex'>
                                                                    <Button className="BulkUpdate__removeBtn " disabled={true}><i className="fas fa-trash-alt"></i></Button>
                                                                    <Button className='BulkUpdate__AddBtn' disabled={disableEdit} onClick={() => { if (prixDetailsLocal?.blackOutDates?.length == 0) { commonOnChange('blackOutDays', [blackOutDays, blackOutDays]) } }}><i className="fas fa-plus-circle"></i></Button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Blackout Airlines</span>
                                            </div>
                                        </div>
                                        {prixDetailsLocal?.blackOutCarrier?.length ? prixDetailsLocal?.blackOutCarrier?.map((blackOutAirlineValue, index) => {
                                            return (<>
                                                <div className="row">
                                                    <div className="col-md-6 cm-col d-flex align-items-center">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                color="primary"
                                                                disabled={disableEdit}
                                                                checked={Boolean(blackOutAirlineValue.isMarkedForDelete)}
                                                                onChange={(e) => {
                                                                if (e) {
                                                                    const isMarkedForDelete = e?.target?.checked;
                                                                    const updatedBlackOutData = prixDetailsLocal?.blackOutCarrier.map((item, idx) =>
                                                                        idx === index ? { ...item, isMarkedForDelete: isMarkedForDelete } : item
                                                                    );
                                                                    commonOnChange('blackOutCarrier', updatedBlackOutData);
                                                                    blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE, index, e.target.checked);
                                                                }
                                                            }}
                                                                />
                                                            }
                                                            label=""
                                                        />
                                                        {/* <label className="cm-head-label">Carrier Code </label> */}
                                                        <TextField label='Carrier Code' className="form-control cm-input autoCapitalise custom-disabled-field" value={blackOutAirlineValue?.displayText} disabled={disableEdit || blackOutAirlineValue.isMarkedForDelete}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    const displayText = e?.target?.value?.toUpperCase();
                                                                    const updatedBlackOutCarrier = prixDetailsLocal?.blackOutCarrier.map((item, idx) =>
                                                                        idx === index ? { ...item, displayText: displayText } : item
                                                                    );
                                                                    commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                if (e) {
                                                                    const displayText = e?.target?.value?.toUpperCase();
                                                                    blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT, index, `${displayText}`)
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label className="cm-head-label"> </label>

                                                        <div className="row custom-disabled-field">
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={blackOutAirlineValue?.aller} disabled={disableEdit || blackOutAirlineValue.isMarkedForDelete} />} label="Departure"
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const aller = e?.target?.checked;
                                                                            const updatedBlackOutCarrier = prixDetailsLocal?.blackOutCarrier.map((item, idx) =>
                                                                                idx === index ? { ...item, aller: aller } : item
                                                                            );
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_ALLER, index, aller)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" checked={blackOutAirlineValue?.retour} disabled={disableEdit || blackOutAirlineValue.isMarkedForDelete} />} label="Return"
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const retour = e?.target?.checked;
                                                                            const updatedBlackOutCarrier = prixDetailsLocal?.blackOutCarrier.map((item, idx) =>
                                                                                idx === index ? { ...item, retour: retour } : item
                                                                            );
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_RETOUR, index)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 cm-col">
                                                        <label className="cm-head-label">Exception Type</label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <Select className='BulkUpdate__DatePicker' value={blackOutAirlineValue?.exceptionType} disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const exceptionType = e?.target?.value;
                                                                            const updatedBlackOutCarrier = prixDetailsLocal?.blackOutCarrier.map((item, idx) =>
                                                                                idx === index ? { ...item, exceptionType: exceptionType } : item
                                                                            );
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.CHANGE_EXCEPTION_TYPE, index, exceptionType)
                                                                        }
                                                                    }}
                                                                >
                                                                    <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                                                    <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                                                    <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                                                </Select>
                                                            </div>
                                                            <div className="col-md-3">
                                                                {(!disableEdit) &&
                                                                    <div className='setD-flex'>
                                                                        <Button
                                                                            className="BulkUpdate__removeBtn"
                                                                            disabled={disableEdit || prixDetailsLocal?.blackOutCarrier?.length == 0}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutCarrier?.length > 0) {
                                                                                    const updatedBlackOutCarrier = prixDetailsLocal.blackOutCarrier.filter((_, i) => i !== index);
                                                                                    commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                                    blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE_INDEX, index)
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </Button>

                                                                        <Button
                                                                            className='BulkUpdate__AddBtn'
                                                                            disabled={disableEdit}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutCarrier?.length > 0) {
                                                                                    const updatedBlackOutCarrier = [...prixDetailsLocal.blackOutCarrier, blackOutCarrier];
                                                                                    commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-plus-circle"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></>)
                                        }) :
                                            <>
                                                <div className="row">
                                                    <div className="col-md-6 cm-col d-flex align-items-center">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                color="primary"
                                                                disabled={disableEdit}
                                                                onChange={(e) => {
                                                                if (e) {
                                                                    const isMarkedForDelete = e?.target?.checked;
                                                                    const updatedBlackOutData = [{ ...blackOutCarrier, isMarkedForDelete: isMarkedForDelete }];
                                                                    commonOnChange('blackOutCarrier', updatedBlackOutData);
                                                                    blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE, 0, e.target.checked);
                                                                }
                                                            }}
                                                                />
                                                            }
                                                            label=""
                                                        />
                                                        {/* <label className="cm-head-label">Carrier Code </label> */}
                                                        <TextField label='Carrier Code' className="form-control cm-input autoCapitalise custom-disabled-field" disabled={disableEdit}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    const displayText = e?.target?.value?.toUpperCase();
                                                                    const updatedBlackOutCarrier = [{ ...blackOutCarrier, displayText: displayText }];
                                                                    commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                if (e) {
                                                                    const displayText = e?.target?.value?.toUpperCase();
                                                                    blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT, 0, `${displayText}`)
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label className="cm-head-label"> </label>

                                                        <div className="row custom-disabled-field">
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit} />} label="Departure"
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const aller = e?.target?.checked;
                                                                            const updatedBlackOutCarrier = [{ ...blackOutCarrier, aller: aller }];
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_ALLER, 0, aller)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <FormControlLabel control={<Checkbox color="primary" disabled={disableEdit} />} label="Return"
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const retour = e?.target?.checked;
                                                                            const updatedBlackOutCarrier = [{ ...blackOutCarrier, retour: retour }];
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_RETOUR, 0)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 cm-col">
                                                        <label className="cm-head-label">Exception Type</label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <Select className='BulkUpdate__DatePicker'disabled={disableEdit}
                                                                    onChange={(e) => {
                                                                        if (e) {
                                                                            const exceptionType = e?.target?.value;
                                                                            const updatedBlackOutCarrier = [{ ...blackOutCarrier, exceptionType: exceptionType }];
                                                                            commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.CHANGE_EXCEPTION_TYPE, 0, exceptionType)
                                                                        }
                                                                    }}
                                                                >
                                                                    <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                                                    <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                                                    <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                                                </Select>
                                                            </div>
                                                            <div className="col-md-3">
                                                                {(!disableEdit) &&
                                                                    <div className='setD-flex'>
                                                                        <Button
                                                                            className='BulkUpdate__AddBtn'
                                                                            disabled={disableEdit}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.blackOutCarrier?.length > 0) {
                                                                                    const updatedBlackOutCarrier = [...prixDetailsLocal.blackOutCarrier, blackOutCarrier];
                                                                                    commonOnChange('blackOutCarrier', updatedBlackOutCarrier);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-plus-circle"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></>
                                        }
                                    </div>
                                </div>

                            </TabPanel>

                            <TabPanel value="3" className='m-0 p-0'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Endorsement</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">VIT</label> */}
                                                    <TextField label='VIT' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={prixDetailsLocal?.endorsement?.VIT} onChange={(e) => { commonOnChange('endorsement', { ...prixDetailsLocal?.endorsement, ['VIT']: e?.target?.value?.toUpperCase() }) }} disabled={disableEdit} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">SKY </label> */}
                                                    <TextField label='SKY' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={prixDetailsLocal?.endorsement?.SKY} onChange={(e) => { commonOnChange('endorsement', { ...prixDetailsLocal?.endorsement, ['SKY']: e?.target?.value?.toUpperCase() }) }} disabled={disableEdit} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">DFW</label> */}
                                                    <TextField label='DFW' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={prixDetailsLocal?.endorsement?.DFW} onChange={(e) => { commonOnChange('endorsement', { ...prixDetailsLocal?.endorsement, ['DFW']: e?.target?.value?.toUpperCase() }) }} disabled={disableEdit} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">FUN</label> */}
                                                    <TextField label='FUN' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={prixDetailsLocal?.endorsement?.FUN} onChange={(e) => { commonOnChange('endorsement', { ...prixDetailsLocal?.endorsement, ['FUN']: e?.target?.value?.toUpperCase() }) }} disabled={disableEdit} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">TC</label> */}
                                                    <TextField label='TC' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={prixDetailsLocal?.endorsement?.TC} onChange={(e) => { commonOnChange('endorsement', { ...prixDetailsLocal?.endorsement, ['TC']: e?.target?.value?.toUpperCase() }) }} disabled={disableEdit} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Tour Code</span>
                                            </div>
                                        </div>
                                        {prixDetailsLocal?.tourCode?.length && prixDetailsLocal?.tourCode?.map((tour, index) => {
                                            return (<>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">Office</label> */}
                                                                    <TextField label='Office'
                                                                        className="form-control cm-input autoCapitalise custom-disabled-field"
                                                                        type="text"
                                                                        value={tour?.marketCode || ''}
                                                                        onChange={(e) => {
                                                                            const newMarketCode = e.target.value?.toUpperCase();
                                                                            const updatedTourCodes = prixDetailsLocal?.tourCode.map((item, idx) =>
                                                                                idx === index ? { ...item, marketCode: newMarketCode } : item
                                                                            );
                                                                            commonOnChange('tourCode', updatedTourCodes);
                                                                        }}
                                                                        disabled={disableEdit}
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">Adult</label> */}
                                                                    <TextField label='Adult' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={tour?.passengerType?.includes("ADULT") ? tour?.tourCodes : null} disabled={disableEdit}
                                                                        onChange={(e) => {
                                                                            const tourCodes = e.target.value?.toUpperCase();
                                                                            const updatedTourCodes = prixDetailsLocal?.tourCode.map((item, idx) =>
                                                                                idx === index ?
                                                                                    {
                                                                                        ...item,
                                                                                        tourCodes: tourCodes,
                                                                                        passengerType: tour?.passengerType?.includes("ADULT")
                                                                                            ? tour?.passengerType
                                                                                            : [...tour?.passengerType, 'ADULT']
                                                                                    }
                                                                                    : item
                                                                            );
                                                                            commonOnChange('tourCode', updatedTourCodes);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">Child</label> */}
                                                                    <TextField label='Child' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={tour?.passengerType?.includes("CHILD") ? tour?.tourCodes : null} disabled={disableEdit}
                                                                        onChange={(e) => {
                                                                            const tourCodes = e.target.value?.toUpperCase();
                                                                            const updatedTourCodes = prixDetailsLocal?.tourCode.map((item, idx) =>
                                                                                idx === index ?
                                                                                    {
                                                                                        ...item,
                                                                                        tourCodes: tourCodes,
                                                                                        passengerType: tour?.passengerType?.includes("CHILD")
                                                                                            ? tour?.passengerType

                                                                                            : [...tour?.passengerType, 'CHILD']
                                                                                    }
                                                                                    : item
                                                                            );
                                                                            commonOnChange('tourCode', updatedTourCodes);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="cm-col">
                                                                    {/* <label className="cm-head-label">Infant</label> */}
                                                                    <TextField label='Infant' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" value={tour?.passengerType?.includes("INFANT") ? tour?.tourCodes : null} disabled={disableEdit}
                                                                        onChange={(e) => {
                                                                            const tourCodes = e.target.value?.toUpperCase();
                                                                            const updatedTourCodes = prixDetailsLocal?.tourCode.map((item, idx) =>
                                                                                idx === index ?
                                                                                    {
                                                                                        ...item,
                                                                                        tourCodes: tourCodes,
                                                                                        passengerType: tour?.passengerType?.includes("INFANT")
                                                                                            ? tour?.passengerType
                                                                                            : [...tour?.passengerType, 'INFANT']
                                                                                    }
                                                                                    : item
                                                                            );
                                                                            commonOnChange('tourCode', updatedTourCodes);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label className="cm-head-label"></label>
                                                                {(!disableEdit) &&
                                                                    <div className='setD-flex'>
                                                                        <Button
                                                                            className="BulkUpdate__removeBtn"
                                                                            disabled={disableEdit || prixDetailsLocal?.tourCode?.length == 0}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.tourCode?.length > 0) {
                                                                                    const updatedTourCode = prixDetailsLocal.tourCode.filter((_, i) => i !== index);
                                                                                    commonOnChange('tourCode', updatedTourCode);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </Button>

                                                                        <Button
                                                                            className='BulkUpdate__AddBtn'
                                                                            disabled={disableEdit}
                                                                            onClick={() => {
                                                                                if (prixDetailsLocal?.tourCode?.length > 0) {
                                                                                    const updatedTourCode = [...prixDetailsLocal.tourCode, tourCode];
                                                                                    commonOnChange('tourCode', updatedTourCode);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-plus-circle"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)
                                        })
                                        }
                                    </div>
                                </div>

                            </TabPanel>
                        </TabContext>
                        {disableEdit ? null : <Box className="cm-card-edit" sx={{ background: '#E1F0FF', padding: '16px', mb: '0' }}>
                            <button className="cm-secondary-btn mr-2" type="button" onClick={() => setDisableEdit(true)}>Cancel</button>
                            <button className="cm-primary-btn mr-2" onClick={() => savePrix()}><i className='fa fa-save mr-1'></i> Save</button>
                            {/* {<button className="cm-primary-btn" onClick={()=>CreateMultiplePrixs()}>Create Multiple Prixs</button>} */}

                        </Box>}
                    </Box>



                </div>
            </div >
        </ >
        }
        </>
    )
}

export default NewPrix